var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManageClinicsIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.672 2.5 2.5 5.76V17.5h14.344V5.759zm0 1.312 5.977 2.718v9.775H3.695V6.53zm-2.87 2.93c-.673 0-1.314.495-1.314 1.21v1.522c0 1.316 1.06 2.351 2.391 2.593v.145c0 1.564 1.18 2.897 2.69 2.897.908 0 1.69-.487 2.174-1.211q.108.016.216.016a1.494 1.494 0 1 0-1.226-.642c-.277.394-.701.642-1.165.642-.8 0-1.494-.726-1.494-1.702v-.145c1.332-.242 2.391-1.277 2.391-2.593V7.953c0-.716-.64-1.211-1.313-1.211h-.48v1.195h.48c.119 0 .118.055.118.016v1.52c0 .741-.724 1.422-1.736 1.448a.6.6 0 0 0-.118 0c-1.01-.027-1.732-.707-1.732-1.447V7.953c0 .039-.001-.016.118-.016h.48V6.742z"
})));
export { SvgManageClinicsIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/manageClinicsIcon.svg";